import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import memoize from 'memoize-one';
import helpers from 'helpers';
import ChannelSummaryCalloutContainer from 'containers/callouts/ChannelSummaryCalloutContainer';

class ChannelSummaryCallouts extends PureComponent {
    constructor(props) {
        super(props);

        this.createCalloutComponents = memoize(ChannelSummaryCallouts.createCalloutComponents);
    }

    static createCalloutComponents({ channels, entityId, layer, disableCalloutLinks, channelOptions }) {
        const calloutComponentMap = channels.reduce((prev, channel) => {
            prev[channel] = <ChannelSummaryCalloutContainer
                key={channel}
                channel={channel}
                entityId={entityId}
                disableLink={disableCalloutLinks}
                exportName={`${layer || 'l3'}-summary-${channel}-callout`}
                channelOptions={channelOptions} />;
            return prev;
        }, {});

        // Used helper to ensure order of channels matches sidebar
        return helpers.orderedChannelKeys(channels).reduce((prev, channel) => {
            const component = calloutComponentMap[channel];
            if (component) {
                prev.push(component);
            }
            return prev;
        }, []);
    }

    render() {
        const channelSummaries = this.createCalloutComponents({
            channels: this.props.channelsList,
            entityId: this.props.entityId,
            layer: this.props.layer,
            disableCalloutLinks: this.props.disableCalloutLinks,
            channelOptions: this.props.channelOptions
        });

        return (
            <React.Fragment>
                {channelSummaries}
            </React.Fragment>
        );
    }
}

ChannelSummaryCallouts.propTypes = {
    channelsList: PropTypes.arrayOf(PropTypes.string).isRequired,
    entityId: PropTypes.number,
    layer: PropTypes.oneOf(['l3', 'l2']),
};

export default ChannelSummaryCallouts;



// WEBPACK FOOTER //
// ./src/components/molecules/ChannelSummaryCallouts.js